import React from 'react';
import { motion } from 'framer-motion';
import { BookOpenIcon, CheckCircle2Icon } from 'lucide-react';
const chapters = [{
  num: '1',
  title: 'El Incendio Nocturno',
  subtitle: 'Protocolo de Alivio en 12 Minutos',
  points: ['La técnica exacta de contraste hidro-térmico para "resetear" los nervios.', 'Checklist de Dormitorio Seguro para evitar disparadores de dolor.', 'Diario de Escala de Ardor para medir tu progreso noche a noche.']
}, {
  num: '2',
  title: 'El Mapa de Inspección SOS',
  subtitle: 'Detectando el Peligro Invisible',
  points: ['Inspección de 5 puntos clave que tu doctor no tiene tiempo de enseñarte.', 'La técnica del Escáner Térmico Manual para detectar infecciones ocultas.', 'Prueba de Llenado Capilar para medir tu circulación en casa.']
}, {
  num: '3',
  title: 'Blindaje Neural',
  subtitle: 'Suplementación y Nutrición en USA',
  points: ['Los 3 jinetes de la reparación nerviosa: ALA, B12 y Magnesio.', 'Qué marcas comprar en CVS, Walgreens o Amazon sin tirar tu dinero.', 'El "Pico de Fuego": Alimentos que disparan el ardor 2 horas después.']
}, {
  num: '4',
  title: 'El Calzado del Sobreviviente',
  subtitle: 'Evitando la Fricción Mortal',
  points: ['La regla de las 4 PM para comprar zapatos que realmente te protejan.', 'El secreto de los calcetines blancos que puede salvar tu pie.', 'Cómo usar tu cobertura de Medicare para calzado especializado.']
}];
export function ChapterPreview() {
  return <section className="py-20 lg:py-28 bg-cream" data-id="element-23">
      <div className="max-w-6xl mx-auto px-5 sm:px-8" data-id="element-24">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-14" data-id="element-25">
          <BookOpenIcon className="w-10 h-10 text-emerald-brand mx-auto mb-3" data-id="element-26" />
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-heading font-bold text-charcoal mb-4" data-id="element-27">
            ¿Qué Encontrarás Dentro del{' '}
            <span className="text-emerald-brand" data-id="element-28">Protocolo SOS</span>?
          </h2>
          <div className="w-20 h-1 bg-gold-brand mx-auto rounded-full" data-id="element-29" />
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-7" data-id="element-30">
          {chapters.map((ch, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-white rounded-2xl p-7 sm:p-8 shadow-md border-l-[6px] border-emerald-brand relative overflow-hidden" data-id="element-31">
              <span className="absolute top-3 right-4 text-7xl font-heading font-bold text-emerald-light/40 select-none" data-id="element-32">
                {ch.num}
              </span>
              <div className="relative z-10 mb-5" data-id="element-33">
                <span className="text-gold-brand font-bold tracking-wider uppercase text-xs font-body" data-id="element-34">
                  Capítulo {ch.num}
                </span>
                <h3 className="text-2xl font-heading font-bold text-charcoal mt-1" data-id="element-35">
                  {ch.title}
                </h3>
                <p className="text-base text-emerald-dark font-medium font-body" data-id="element-36">
                  {ch.subtitle}
                </p>
              </div>
              <ul className="space-y-3 relative z-10" data-id="element-37">
                {ch.points.map((pt, j) => <li key={j} className="flex items-start gap-2.5" data-id="element-38">
                    <CheckCircle2Icon className="w-5 h-5 text-emerald-brand flex-shrink-0 mt-0.5" data-id="element-39" />
                    <span className="text-base sm:text-lg font-body text-gray-700" data-id="element-40">
                      {pt}
                    </span>
                  </li>)}
              </ul>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 15
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mt-8 bg-gold-brand/10 border border-gold-brand/30 rounded-2xl p-7 text-center" data-id="element-41">
          <p className="text-xl sm:text-2xl font-heading font-bold text-charcoal mb-1" data-id="element-42">
            🎁 BONUS INCLUIDOS
          </p>
          <p className="text-lg font-body text-gray-700" data-id="element-43">
            Preguntas Frecuentes, Glosario de Términos Médicos y Directorio
            Completo de Recursos en USA.
          </p>
        </motion.div>
      </div>
    </section>;
}